/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ChatMessageDto } from '../models/chat-message-dto';
import { MessageDto } from '../models/message-dto';

@Injectable({
  providedIn: 'root',
})
export class CustomerSupportMessageControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation sendCustomerSupportMessages
   */
  static readonly SendCustomerSupportMessagesPath = '/api/v1/sendMessage';

  /**
   * customer support API.
   *
   * API id for to send customer support messages
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendCustomerSupportMessages()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendCustomerSupportMessages$Response(params: {
    secretKey: string;
    body: ChatMessageDto
  }
): Observable<StrictHttpResponse<MessageDto>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerSupportMessageControllerService.SendCustomerSupportMessagesPath, 'post');
    if (params) {
      rb.header('apiKey', params.secretKey, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
    accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MessageDto>;
      })
    );
  }

  /**
   * customer support API.
   *
   * API id for to send customer support messages
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendCustomerSupportMessages$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendCustomerSupportMessages(params: {
    secretKey: string;
    body: ChatMessageDto
  }
): Observable<MessageDto> {

    return this.sendCustomerSupportMessages$Response(params).pipe(
      map((r: StrictHttpResponse<MessageDto>) => r.body as MessageDto)
    );
  }

}
